import React, {useCallback, useEffect, useMemo} from 'react';
import {useInjectSaga} from 'utils/injectSaga';
import companySaga from 'sagas/companySaga';
import teamSaga from 'sagas/teamSaga';
import rolesSaga from 'sagas/rolesSaga';
import {fetchCountries} from 'actions/companyActions';
import {fetchRoles} from 'actions/rolesAction';
import {useDispatch, useSelector} from 'react-redux';
import {
  createUpdateTeam,
  getTeamMembers,
  updateStatus,
} from 'actions/teamActions';

import Table from './Table';
import './people.scss';

export default function People() {
  const dispatch = useDispatch();
  useInjectSaga({key: 'company', saga: companySaga});
  useInjectSaga({key: 'team', saga: teamSaga});
  useInjectSaga({key: 'role', saga: rolesSaga});
  const roles = useSelector((state) => state.roles.roles);
  const targetRole = roles.find((role) => role.title === 'editor') || {};
  useEffect(() => {
    getItems();
    dispatch(fetchCountries());
    dispatch(fetchRoles());
  }, []);

  const team = useSelector((state) => state.team);
  const {teams} = team;

  const createUpdateStatus = useMemo(
    () => ({
      submitting: team.submitting,
      createSuccess: team.createSuccess,
      createFailed: team.createFailed,
      error: team.statusText,
      id: team.itemId,
    }),
    [team]
  );

  const createUpdateItem = useCallback((item) => {
    dispatch(createUpdateTeam(item._id, item, 'people-accounts'));
  }, []);

  const getItems = useCallback(() => {
    dispatch(getTeamMembers('people-accounts'));
    dispatch(updateStatus());
  }, []);

  return (
    <div className="admin-people">
      {(team.fetchFailed || team.createFailed) && (
        <p role="alert">
          {team.createFailed ? team.statusText : 'Could not load the accounts.'}{' '}
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={getItems}
          >
            Reload accounts
          </button>
        </p>
      )}
      {team.fetching && !teams?.length && (
        <p role="status">Loading accounts…</p>
      )}
      {team.fetchSuccess && !teams?.length && (
        <p>
          No active teams. <a href="/admin/team">Manage teams</a>
        </p>
      )}
      {teams?.map((group, i) => (
        <Table
          key={group._id}
          team={group}
          index={i}
          createUpdateItem={createUpdateItem}
          getItems={getItems}
          targetRole={targetRole}
          createUpdateStatus={createUpdateStatus}
        />
      ))}
    </div>
  );
}
